import React from 'react';

import {
  Container,
  Grid,
  Icon,
  Header,
  Image,
  Segment,
  Responsive,
} from 'semantic-ui-react';
import FEMALogo from 'app-ui-componentlibrary/dist/go/images/FEMA_logo.svg';

export const Footer = () => (
  <Segment inverted basic id="footer" className="mediumGray" compact>
    <Container id="footerContent">
      <Grid padded stackable>
        <Grid.Row>
          <Grid.Column width={2}>
            <a title="fema.gov" href="https://www.fema.gov" target="_blank">
              FEMA.gov
            </a>
          </Grid.Column>
          <Grid.Column width={2}>
            <a title="dhs.gov" href="https://www.dhs.gov" target="_blank">
              DHS.gov
            </a>
          </Grid.Column>
          <Grid.Column width={2}>
            <a title="grants.gov" href="https://www.grants.gov" target="_blank">
              Grants.gov
            </a>
          </Grid.Column>
          <Grid.Column width={8} floated="right" align="right">
            <Header as="h4">FEMA GO Help Desk</Header>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={3} floated="left" align="left">
            <Image
              size="small"
              alt="U.S. Department of Homeland Security - FEMA"
              src={FEMALogo}
            />
          </Grid.Column>
          <Grid.Column width={8} floated="right" align="right">
            <a
              className="email-link"
              title="femago@fema.dhs.gov"
              href="mailto:femago@fema.dhs.gov"
            >
              femago@fema.dhs.gov
            </a>
            <p className="footer-text">FEMA GO technical support: 1-877-585-3242</p>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  </Segment>
);

export default Footer;
